// Copyright (c) 2016 Deere & Company

import CreateClaimCellRenderer from '../../shared/report-cell-renderers/create-claim-cell-renderer';
import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getMassChannelColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: CreateClaimCellRenderer,
            colId: 'create-claim',
            field: 'pin',
            headerClass: classNames.headerClassName,
            headerName: translate('CREATE_CLAIM'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 190
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'retailerName',
            field: 'retailerName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('RETAILER_NAME'),
            width: 250

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'customerName',
            field: 'customerName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CUSTOMER_NAME'),
            width: 250

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'phone',
            field: 'phone',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PHONE'),
            width: 160
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'street1',
            field: 'street1',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('STREET_1'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'street2',
            field: 'street2',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('STREET_2'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'city',
            field: 'city',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CITY'),
            width: 160
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'region',
            field: 'region',
            headerClass: classNames.headerClassName,
            headerName: translate('REGION'),
            width: 100
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'postalCode',
            field: 'postalCode',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('POSTAL_CODE'),
            width: 120
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'country',
            field: 'country',
            headerClass: classNames.headerClassName,
            headerName: translate('COUNTRY'),
            width: 100
        },

        {
            cellClass: classNames.cellLeftClassName,
            colId: 'email',
            field: 'email',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('EMAIL'),
            width: 250

        },
        {
            cellClass: classNames.cellClassName,
            colId: 'model',
            field: 'model',
            headerClass: classNames.headerClassName,
            headerName: translate('MODEL'),
            width: 180
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'deliveryDate',
            field: 'deliveryDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('DELIVERED'),
            width: 100

        },
        {
            cellClass: classNames.cellClassName,
            colId: 'legacyCustomer',
            field: 'dealer.account',
            headerClass: classNames.headerClassName,
            headerName: translate('ACCOUNT'),
            width: 100
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerCity',
            field: 'dealer.name',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER_NAME'),
            width: 250
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerCity',
            field: 'dealer.location.city',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER_CITY'),
            width: 170
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'dealerState',
            field: 'dealer.location.state',
            headerClass: classNames.headerClassName,
            headerName: translate('DEALER_STATE'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerPostalCode',
            field: 'dealer.location.postalCode',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER_POSTAL_CODE'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerPhone',
            field: 'dealer.phone',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER_PHONE'),
            width: 170
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/mass-channel-customer-follow-up/report-services/column-definitions.js